import { ServerKlarityService } from 'types/common';

export const generateNewItem = (index: number, serviceTypeId: number, contextType: string, sequence: number) => {
    const item: any = {
        presetId: index + 1,
        serviceTypeId,
        type: contextType,
        sequence: sequence ? sequence + 1 : index + 1,
    };
    if (contextType === 'patientGroup') {
        item.patientGroup = '';
    } else if (contextType === 'limitation') {
        item.limitation = '';
    }

    return item;
};

export const validationForInsuranceTable = (serviceData: ServerKlarityService[]) => {
    const errors: string[] = [];

    serviceData.forEach((service) => {
        const { serviceType, serviceStateItems, insurances } = service;
        const serviceCashPay = service.cashPay;
        const serviceInsurancePay = service.insurancePay;
        serviceStateItems.forEach((stateItem) => {
            const { state, patientCost, cashPay, insurancePay } = stateItem;
            //这里状态重置有问题，2层都为true才校验。
            const checkCashPay = serviceCashPay && cashPay;
            const checkInsurancePay = serviceInsurancePay && insurancePay;

            // 场景1: cashPay=true, insurancePay=false - 检查patientCost是否存在
            if (checkCashPay && !checkInsurancePay) {
                if (!patientCost || patientCost === 0) {
                    errors.push(`${serviceType}: ${state} has not set patientCost`);
                }
            }

            // 场景2: cashPay=false, insurancePay=true - 检查insurances字段中是否有对应的state
            if (!checkCashPay && checkInsurancePay) {
                const hasInsuranceForState = insurances?.some((insurance) => insurance.state === state);
                if (!hasInsuranceForState) {
                    errors.push(`${serviceType}: ${state} has not set insurance`);
                }
            }

            // 场景3: cashPay=false, insurancePay=false - 必须设置一种payment method
            if (!checkCashPay && !checkInsurancePay) {
                errors.push(`${serviceType}: ${state} must set one payment method`);
            }

            // 场景4: cashPay=true, insurancePay=true - 按照1和2的校验方式
            if (checkCashPay && checkInsurancePay) {
                // 检查patientCost
                if (!patientCost || patientCost === 0) {
                    errors.push(`${serviceType}: ${state} has not set patientCost`);
                }

                // 检查insurance
                const hasInsuranceForState = insurances.some((insurance) => insurance.state === state);
                if (!hasInsuranceForState) {
                    errors.push(`${serviceType}: ${state} has not set insurance`);
                }
            }
        });
    });

    return {
        isValid: errors.length === 0,
        errors,
    };
};

export const getPaymentType = (serviceData: ServerKlarityService) => {
    // 如果serviceData为空或没有serviceStateItems，返回0
    if (!serviceData || !serviceData.serviceStateItems || serviceData.serviceStateItems.length === 0) {
        return 0;
    }

    // 检查所有serviceStateItems的cashPay和insurancePay状态
    const allCashPayStates: boolean[] = [];
    const allInsurancePayStates: boolean[] = [];

    serviceData.serviceStateItems.forEach(() => {
        // 从service级别获取cashPay和insurancePay状态
        allCashPayStates.push(serviceData.cashPay === true);
        allInsurancePayStates.push(serviceData.insurancePay === true);
    });

    // 如果没有状态项，返回0
    if (allCashPayStates.length === 0) {
        return 0;
    }

    // 检查所有cashPay是否都为true，所有insurancePay是否都为false
    const allCashPayTrue = serviceData.serviceStateItems.every((stateItem) => stateItem.cashPay);
    const allInsurancePayFalse = !serviceData.insurances || serviceData.insurances.length === 0;

    if (allCashPayTrue && allInsurancePayFalse) {
        return 1; // 纯现金支付
    }

    // 检查所有cashPay是否都为false，所有insurancePay是否都为true
    const allCashPayFalse = serviceData.serviceStateItems.every((stateItem) => !stateItem.cashPay);
    const allInsurancePayTrue = serviceData.insurances && serviceData.insurances.length > 0;

    if (allCashPayFalse && allInsurancePayTrue) {
        return 2; // 纯保险支付
    }

    // 其他情况：混合支付方式
    return 3;
};
